import { render, staticRenderFns } from "./BuyPannel.vue?vue&type=template&id=379e02f4&"
import script from "./BuyPannel.vue?vue&type=script&lang=js&"
export * from "./BuyPannel.vue?vue&type=script&lang=js&"
import style0 from "./BuyPannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports